export default function DspAppNexusController(
  $state,
  CreativeService,
  DspService,
  RenderService,
  FlashService,
  SitesService
) {
  const vm = this;
  vm.name = 'AppNexus';
  vm.id = $state.params.id;
  vm.creativeService = CreativeService;
  vm.renderService = RenderService;
  vm.loading = true;

  SitesService.fetchPartnerSites().then(partnerSites => {
    SitesService.partnerSites = partnerSites;
    RenderService.setSite();
  });

  DspService.getAppnexus($state.params.id).then(
    ({ data }) => {
      vm.loading = false;
      CreativeService.creative = data;
      RenderService.renderDemo();
    },
    ({ data }) => {
      vm.loading = false;
      FlashService.push('error', data.error);
      $state.go('dsp.home');
    }
  );

  return vm;
}

DspAppNexusController.$inject = [
  '$state',
  'CreativeService',
  'DspService',
  'RenderService',
  'FlashService',
  'SitesService'
];
